<template>
  <div>
    <v-dialog class="pa-0 ma-0" v-if="sdialog" v-model="sdialog" persistent>
      <generic-dialog
        :dialogTitle="editedIndex < 0 ? 'Add New Item' : 'Edit Item'"
        @returnValue="returnValue"
        :item="editedItem"
        :editIndex="editedIndex"
        :headers="headers"
        :editables="editables"
        :errorObj="{}"
        :table="table"
      />
    </v-dialog>
    <v-dialog
      v-if="formdialog"
      v-model="formdialog"
      persistent
      width="unset"
    >
      <FormDialog :show.sync="formdialog" :args="formdata"></FormDialog>
    </v-dialog>
    <v-dialog
      v-if="docdialog && !simple"
      v-model="docdialog"
      persistent
      fullscreen
      height="unset"
    >
      <DocumentViewer :show.sync="docdialog" :args="ddata"> </DocumentViewer>
    </v-dialog>
    <v-dialog
      v-if="!simple && !embed"
      v-model="dateDialog"
      max-width="450px"
      height="500px"
    >
      <v-card>
        <v-card-title>
          <dateRangePicker
            :inline="true"
            show-reset
            :dark="dark"
            @daterange="setDateRange"
          />
        </v-card-title>
      </v-card>
    </v-dialog>

    <v-container fluid id="mycontainer">
      <div ref="outer" id="outer">
        <v-data-table
          :class="
            simple
              ? dark
                ? 'inset-v-data-table-dark'
                : 'inset-v-data-table'
              : 'top-v-data-table elevation-1'
          "
          show-expand
          ref="table"
          :headers="headers"
          :items="rows"
          dense
          fixed-header
          hide-default-header
          hide-default-footer
          :height="computedHeight"
          :sortable="true"
          :options.sync="options"
          :server-items-length="serverItemsLength"
          :loading="tableLoading"
          loading-text="Loading... Please wait"
          :expanded.sync="expanded"
          item-key="_id"
          single-expand
          v-model="selectedRows"
        >
          <template v-slot:top>
            <div v-if="!simple">
              <v-toolbar flat>
                <v-toolbar-title>{{ tableName | phrasemap }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>

                <v-col class="ma-0 pa-0" v-if="!embed">
                  <v-row>
                    <v-btn
                      class="pa-0 ma-0"
                      :disabled="hiddenColumns.length == 0"
                      small
                      color="primary"
                      style="width: 200px"
                      @click="unhideColumns()"
                    >
                      Show Hidden Columns
                    </v-btn>
                  </v-row>
                  <v-row>
                    <v-btn
                      class="pa-0 ma-0 mt-1"
                      small
                      color="primary"
                      style="width: 200px"
                      @click="active = !active"
                    >
                      {{
                        active
                          ? "Showing Active Records"
                          : "Showing All Records"
                      }}
                    </v-btn>
                  </v-row>
                </v-col>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  v-if="!embed"
                ></v-divider>

                <v-col class="pa-0 pb-1 ma-0" v-if="!embed">
                  <v-row class="pa-0 ma-0" align="center">
                    <v-icon small class="pa-0 ma-0"> mdi-filter </v-icon>
                    <span
                      v-html="
                        filterColumn.text == null
                          ? 'Column to Search'
                          : filterColumn.text.replace('<br>', ' ')
                      "
                      style="margin: 2px"
                    ></span>
                  </v-row>
                  <input
                    ref="filterTextWidget"
                    v-show="filterColumn.value != null"
                    :style="{
                      color: dark ? 'lightgray' : 'black',
                      border: '1px solid cornflowerblue',
                      fontSize: '0.9em',
                      padding: '8px',
                    }"
                    @input="debounceSearch"
                    placeholder="Text to Search for"
                  />
                </v-col>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  v-if="!embed"
                ></v-divider>

                <v-col class="pa-0 ma-0 pt-2" v-if="!embed">
                  <v-row class="pa-0 pb-3 ma-0" align="center">
                    <v-icon small>mdi-calendar</v-icon>
                    <v-label class="pa-0 pb-8 ma-0">
                      {{ selectedDateFieldText || "Last Update" }}
                    </v-label>
                  </v-row>
                  <v-row class="pa-0 pb-3 ma-0" align="center">
                    <v-icon
                      small
                      color="red"
                      :disabled="dateRangeString() == 'All Dates'"
                      @click="setDateRange(null)"
                      >mdi-close</v-icon
                    >
                    <span>{{ dateRangeString() }}</span>
                  </v-row>
                </v-col>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  v-if="!embed"
                ></v-divider>
                <v-btn
                  v-if="!embed"
                  class="pa-0 ma-0 white--text"
                  small
                  :color="refreshRequired ? 'deep-orange' : 'primary'"
                  style="width: 100px"
                  @click="
                    updateSortedTable();
                    refreshRequired = false;
                  "
                >
                  Refresh
                </v-btn>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  v-if="!embed"
                ></v-divider>
                <div id="fselector" v-if="!embed">
                  <v-btn-toggle id="fselector" v-model="fontSizeIndex">
                    <v-btn x-small>
                      <span style="font-size: 8px">A</span>
                    </v-btn>
                    <v-btn x-small>
                      <span style="font-size: 10px">A</span>
                    </v-btn>
                    <v-btn x-small>
                      <span style="font-size: 12px">A</span>
                    </v-btn>
                  </v-btn-toggle>
                </div>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  v-if="!embed"
                ></v-divider>
                <div class="flex-grow-1" v-if="embed"></div>
                <v-btn v-if="editable" small color="primary" @click="addItem()">
                  Add Item
                </v-btn>

                <!-- </v-row> -->
              </v-toolbar>
            </div>
            <div v-if="simple && top != null">
              <h2 class="ma-3" v-if="top.title">{{ table | phrasemap }}</h2>
              <div v-if="top.add">
                <v-btn small color="primary" @click="addItem()">
                  Add Item
                </v-btn>
              </div>
              <component
                v-if="top.component"
                :is="top.component"
                :props="top.props"
              >
              </component>
            </div>
          </template>

          <template v-slot:header="{ props: { headers } }">
            <thead style="z-index: 10">
              <tr>
                <th
                  :class="[
                    h.class,
                    'column sortable',
                    h.value === options.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(h.value)"
                  :style="borderColor"
                  style="
                    min-width: 80px;
                    border-top: 1px solid gray;
                    border-bottom: 1px solid gray;
                  "
                  v-for="(h, idx) in headers"
                  v-show="h.show && !hiddenColumns.includes(h.value)"
                  :key="idx"
                >
                  <v-row
                    v-if="!simple"
                    style="
                      position: absolute;
                      left: 20px;
                      top: 3px;
                      padding-bottom: 10px;
                    "
                  >
                    <v-icon
                      small
                      v-if="options.descending && h.value == options.sortBy"
                      :color="h.value == options.sortBy ? 'green' : 'gray'"
                      >arrow_downward</v-icon
                    >
                    <v-icon
                      small
                      v-else
                      :color="h.value == options.sortBy ? 'green' : 'gray'"
                      >arrow_upward</v-icon
                    >
                    <v-icon
                      class="no-rotate"
                      :color="filterColumn.value == h.value ? 'green' : 'gray'"
                      @click.stop="searchFilter(h)"
                      small
                      >mdi-filter</v-icon
                    >
                    <v-icon
                      class="no-rotate"
                      color="red"
                      @click.stop="hideThisColumn(h)"
                      small
                      >mdi-close</v-icon
                    >
                    <v-icon
                      v-if="isThisDateField(h.value)"
                      class="no-rotate"
                      :color="selectedDateField == h.value ? 'green' : 'gray'"
                      @click.stop="setDateField(h)"
                      small
                      >mdi-calendar</v-icon
                    >
                  </v-row>

                  <v-row
                    align="start"
                    :style="{ paddingTop: simple ? '0px' : '25px' }"
                  >
                    <span
                      class="float-right"
                      style="fontsize: 1.2em; color: #159897"
                      v-html="h.text"
                    ></span>
                  </v-row>
                </th>
                <th
                  v-if="editable && rows.length > 0"
                  style="
                    border-top: 1px solid gray;
                    border-bottom: 1px solid gray;
                  "
                >
                  <span style="fontsize: 1.2em; color: #159897"> Actions </span>
                </th>
              </tr>
            </thead>
          </template>

          <template v-slot:expanded-item="{ headers /*, item*/ }">
            <td class="pa-9 pt-0" :colspan="headers.length">
              <v-card>
                <div v-if="excomponent == null">
                  <server-table-component
                    :rowProp="exRowProp"
                    :schemaProp="exSchemaProp"
                    :simple="true"
                    :editable="false"
                  >
                  </server-table-component>
                </div>
              </v-card>
            </td>
          </template>

          <!-- <template v-slot:body="{ items }">
            <tbody> -->
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr
              :class="selectedRows.indexOf(item._id) > -1 ? 'cyan' : ''"
              @click="rowClicked(item)"
            >
              <td
                :style="borderColor + fontSize"
                v-for="(h, idx) in headers"
                :key="idx"
                v-show="h.show && !hiddenColumns.includes(h.value)"
                :class="h.align === 'right' ? 'text-xs-right' : 'text-xs-left'"
              >
                <div v-if="h.component === 'status'" style="padding-left: 10px">
                  <CircleStatus :state="item[h.value]"></CircleStatus>
                </div>
                <div
                  v-else-if="h.component === 'circulargauge' && item[h.value]"
                  :key="item._id"
                >
                  <v-layout
                    row
                    wrap
                    style="width: 99%"
                    @click="rowClicked(item)"
                  >
                    <div v-for="(g, index) in item[h.value]" :key="index">
                      <SmallGauge
                        style="margin-left: 10px"
                        :prop="{ g: g, item: item, index: index }"
                      ></SmallGauge>
                    </div>
                  </v-layout>
                </div>
                <div
                  v-else-if="
                    formatItem({
                      i: item,
                      h: h,
                      e: editables,
                      a: true,
                      c: clickAction,
                    }) === true
                  "
                  :style="{ cursor: 'pointer' }"
                  @click="
                    clickAction[h.value]['t'] != 'file'
                      ? expand(!isExpanded)
                      : () => {};
                    cellClicked(item, h);
                  "
                >
                  <span
                    v-html="
                      formatItem({ i: item, h: h, e: editables, t: false })
                    "
                  ></span>
                  <v-icon :color="clickIcon(item, h.value)[1]" small>{{
                    clickIcon(item, h.value)[0]
                  }}</v-icon>
                </div>
                <div v-else-if="h.component == 'document' && item[h.value]">
                  <v-btn
                    color="green"
                    @click="openDoc(table, h.value, item[h.value], item)"
                    >{{ h.text }}</v-btn
                  >
                </div>
                <div v-else-if="isImage(h) == true">
                  <v-icon
                    v-if="images == null || images[item._id] === undefined"
                    >mdi-image-off
                  </v-icon>
                  <v-tooltip left v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        :src="images[item._id]"
                        width="50px"
                        height="35px"
                        v-bind="attrs"
                        v-on="on"
                      >
                      </v-img>
                    </template>
                    <v-img :src="images[item._id]" width="300px" height="100%">
                      <span style="background-color: black; color: yellow">{{
                        item["name"] == undefined ? item["mtag"] : item["name"]
                      }}</span>
                    </v-img>
                  </v-tooltip>
                </div>
                <div v-else>
                  <v-tooltip
                    left
                    :disabled="h.format && h.format.search('qrcode') < 0"
                  >
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{
                          formatItem({ i: item, h: h, e: editables, t: false })
                        }}</span
                      >
                    </template>
                    <v-col align="center">
                      <v-row justify="center">{{ item[h.value] }}</v-row>
                      <v-row justify="center">
                        <qr-code
                          :text="item[h.value]"
                          :size="125"
                          color="#ffffff"
                          bg-color="#000000"
                          error-level="L"
                        >
                        </qr-code>
                        <!-- <vue-qrious :value="item[h.value]" background="#ffffff" level="H"/> -->
                      </v-row>
                    </v-col>
                  </v-tooltip>
                </div>
              </td>
              <td v-if="editable" :style="borderColor">
                <v-icon
                  small
                  class="mr-2"
                  color="blue"
                  :disabled="item.ed == 'no' && origUser.role != 'super'"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(item)"
                  :disabled="item.delete == 'no' && origUser.role != 'super'"
                  color="red"
                >
                  mdi-delete
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>

    <div
      v-if="
        (serverItemsLength == undefined && rows.length > 1) ||
        serverItemsLength > 1
      "
      style="padding-left: 20px; padding-right: 20px"
    >
      <v-row justify="start" align="center">
        <v-flex lg4 md4>
          <v-row
            justify="start"
            align="center"
            style="padding: 0px; padding-left: 20px"
          >
            <v-label v-if="!simple" style="padding-right: 10px">{{
              "Rows Per Page - "
            }}</v-label>
            <v-btn-toggle v-model="toggleExclusive" mandatory rounded>
              <v-btn small>10</v-btn>
              <v-btn small>20</v-btn>
              <v-btn small>30</v-btn>
              <v-btn small>40</v-btn>
            </v-btn-toggle>
          </v-row>
        </v-flex>
        <v-flex lg2 md2>
          <div style="text-align: center">
            {{
              serverItemsLength == undefined ? rows.length : serverItemsLength
            }}
            Items
          </div>
        </v-flex>
        <v-flex lg6 md6 style="padding-right: 20px">
          <v-pagination :circle="simple" v-model="options.page" :length="pages">
          </v-pagination>
        </v-flex>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { sync } from "vuex-pathify";
  import utils from "../helpers/utils";
  import cache from "../helpers/cache";
  import preprocess from "../helpers/preprocess.js";
  import CircleStatus from "../library/checkStatus";
  import SmallGauge from "../library/SmallGauge";
  import axiosInstances from "../server/axiosInstances";
  // import Vue from 'vue'
  import moment from "moment";
  import uuid from "uuid";
  import querystring from "querystring";
  import dateRangePicker from "../library/DateRangePicker";
  import FullPageDialog from "../library/FullPageDialog";
  import PopupDialog from "../library/PopupDialog";
  import DocumentViewer from "../library/DocumentDialog";
  import BuildCallbacks from "@/mixins/buildCallbacks.js";
  import FormDialog from "@/../../library/view/Dialog";
  import VueQrious from "vue-qrious";
  export default {
    name: "server-table-component",
    components: {
      CircleStatus,
      SmallGauge,
      dateRangePicker,
      FullPageDialog,
      PopupDialog,
      DocumentViewer,
      VueQrious,
      FormDialog,
    },
    props: {
      top: {
        type: Object,
        required: false,
        default: null,
      },
      editable: {
        type: Boolean,
        required: false,
        default: true,
      },
      server: {
        type: String,
        required: false,
        default: function () {
          return "api";
        },
      },
      table: {
        type: String,
        required: false,
        default: null,
      },
      newtable: {
        type: String,
        required: false,
        default: null,
      },
      arrayKey: {
        type: String,
        required: false,
        default: null,
      },
      schema: {
        type: String,
        required: false,
        default: null,
      },
      simple: {
        type: Boolean,
        required: false,
        default: false,
      },
      embed: {
        type: Boolean,
        required: false,
        default: false,
      },
      rowProp: {
        type: Array,
        required: false,
        default: null,
      },
      schemaProp: {
        type: Object,
        required: false,
        default: null,
      },
      refresh: {
        type: Boolean,
        required: false,
        default: false,
      },
      filter: {
        type: Object,
        required: false,
        default: null,
      },
      enableRowClick: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    mixins: [BuildCallbacks],

    data: () => ({
      refreshRequired: false,
      selectedRows: [],
      needToUpdate: false,
      needToUpdateTrigger: null,
      tableName: null,
      editedIndex: -1,
      exRowProp: null,
      exSchemaProp: null,
      excomponent: null,
      tableLoading: false,
      clickedCellValue: null,
      clickedRowId: null,
      expanded: [],
      fontSizeIndex: 1,
      dateDialog: false,
      filterColumn: { text: null, value: null },
      filterText: null,
      toggleExclusive: 1,
      height: "100%",
      rows: [],
      tempheaders: [],
      viewport: "70vh",
      images: null,
      tempImages: null,
      hasImages: false,
      tableserver: null,
      editedItem: {},
      sdialog: false,
      docdialog: false,
      formdialog: false,
      formdata: null,
      dialogProp: {
        component: null,
      },
      dialogMainComponent: sync("dialogMainComponent"),
      activeItems: true,
      dRange: null,
      selectedDateField: null,
      selectedDateFieldText: null,
      advanced: false,
      columns: [],
      hiddenColumns: [],
      filterDateTypes: [],
      filterType: null,
      active: true,
      printIcon: "mdi-printer",
      clickAction: {},
      expandedState: false,
      remote: false,
      remotefield: "",
      search: "",
      // excomponent: null,
      searchLabel: "Click on circle by header to search",
      searchText: {},
      printIcons: {},
      numitems: 0,
      serverItemsLength: undefined,
      page: 1,
      itemsPerPage: 10,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        descending: true,
      },
      oldpage: 0,
      dfilter: [],
      headers: [],
      // showHeaders: [],
      editables: [],
      docdata: {},
      lastUpdated: null,
      updateTrigger: null,
      lastUpdatedReal: null,
      updateTriggerReal: null,
      imagesOnServer: [],
    }),
    computed: {
      computedHeight() {
        if (this.embed) return undefined;
        else return this.height;
      },
      fontSize() {
        return (
          "padding: 3px; font-size: " +
          (this.fontSizeIndex * 2 + 10).toString() +
          "px;"
        );
      },
      borderColor() {
        return this.dark
          ? "border-right: 1px solid rgb(52, 52, 52); border-bottom: 1px solid rgb(52, 52, 52);"
          : "border-right: 1px solid rgb(220,220,220)	;border-bottom: 1px solid rgb(220,220,220)	;";
      },
      bottomSlot: sync("misc/bottomSlot"),
      ddata() {
        return this.docdata;
      },
      pages() {
        return this.serverItemsLength == undefined
          ? Math.ceil(this.rows.length / this.options.itemsPerPage)
          : Math.ceil(this.serverItemsLength / this.options.itemsPerPage);
      },
      dark: sync("misc/dark"),
      printerObj: sync("printerObj"),
      printerType: sync("printerType"),
      language: sync("misc/language"),
      addButtonName: sync("table/tableAddButtonName"),
      // tableName: sync("table/tableName"),
      title: sync("tableTitle"),
      rowClickFunction: sync("table/tableRowClickFunction"),
      currentOrg: sync("currentOrg"),
      dialog: sync("dialogOpen"),
      mqttClient: sync("mqttClient"),
      user: sync("login/loggedinUser"),
      origUser: sync("login/origLoggedinUser"),
      fullPage: sync("dialog/dialogIsFullPage"),
      stRowAddFunction: sync("stRowAddFunction"),
      facility: sync("login/facility"),
      formTitle() {
        return this.editedIndex === -1 ? "New Item" : "Edit Item";
      },
      mqttTableUpdated: sync("mqtt/mqttTableUpdated"),
    },
    filters: {
      cellFilter: utils.cellFilter,
    },
    watch: {
      enableRowClick(val) {
        this.selectedRows = [];
      },
      facility(val) {
        if (val != null) {
          this.needToUpdate = true;
        }
      },
      needToUpdate(val) {
        this.elog("trace", "needToUpdate set to: {}", val)();
        if (!val) return;
        clearTimeout(this.needToUpdateTrigger);
        var self = this;
        this.needToUpdateTrigger = setTimeout(async function () {
          await self.updateSortedTable();
        }, 500);
      },
      async filterText(val) {
        this.options.page = 1;
        if (val != null) {
          this.elog(
            "debug",
            "Searching for {} in {}",
            val,
            this.filterColumn.value
          )();
          // await this.updateSortedTable();
          this.needToUpdate = true;
        }
      },
      async table(val) {
        // was newtable
        this.options.page = 1;
        this.$refs["filterTextWidget"].value = "";
        this.filterText = null;
        this.elog("trace", "updating sorted table from table watch")();
        // await this.updateSortedTable();
        this.needToUpdate = true;
      },
      rowProp: {
        immediate: true,
        async handler(val) {
          this.elog("trace", "ROWPROP CHANGED")();
          // await this.updateSortedTable();
          this.needToUpdate = true;
        },
      },
      schemaProp: {
        immediate: true,
        async handler(val) {
          if (val != null) {
            this.options.page = 1;
            this.headers = val.headers;
            this.editables = val.editables;
          }
          // await this.updateSortedTable();
          this.needToUpdate = true;
        },
      },
      toggleExclusive: {
        immediate: true,
        handler(val) {
          this.options.itemsPerPage = (val + 1) * 10;
        },
      },
      async $route() {
        this.elog("trace", "route updated, calling init")();
        await this.init();
      },

      options: {
        async handler(newVal, oldVal) {
          this.elog("trace", "Options watcher updating Sorted Table")();
          // await this.updateSortedTable();
          this.needToUpdate = true;
        },
        deep: true,
      },
      active: {
        async handler() {
          // await this.updateSortedTable();
          this.needToUpdate = true;
        },
      },
      mqttTableUpdated: {
        async handler(val) {
          this.elog("debug", "mqtt callback for updating table: {}", val)();
          if (val === this.table) {
            this.refreshRequired = true;
          }
          return;
          // automatic refresh disabled
          // if (val === this.table) {
          //   this.mqttTableUpdated = ''
          //   // reset flag
          //   if (this.lastUpdated == null || Math.abs(moment().diff(this.lastUpdated, 'seconds')) > 2) {
          //     this.lastUpdated = moment()
          //     await this.updateSortedTable()
          //   } else {
          //     clearTimeout(this.updateTrigger)
          //     var self = this
          //     this.updateTrigger = setTimeout(function() {
          //       // self.realUpdateSortedTable()
          //       self.needToUpdate = true
          //     },2000)
          //   }
          // }
        },
      },
      selectedDateField(val) {
        this.updateDateRangeFilter();
      },
    },
    methods: {
      async updateSortedTable(hideLoading) {
        await this.realUpdateSortedTable(hideLoading);
        this.elog("debug", "Rows: {}", this.rows)();
      },
      debounceSearch(event) {
        clearTimeout(this.debounce);
        this.options.page = 1;
        let self = this;
        self.debounce = setTimeout(() => {
          self.filterText = event.target.value;
        }, 1000);
      },
      rowClicked(val) {
        if (this.enableRowClick) this.toggleSelection(val._id);
        if (this.rowClickFunction != null) {
          this.rowClickFunction(val);
        }
      },
      toggleSelection(keyID) {
        if (this.selectedRows.includes(keyID)) {
          this.selectedRows = this.selectedRows.filter(
            (selectedKeyID) => selectedKeyID !== keyID
          );
        } else {
          this.selectedRows.push(keyID);
        }
        if (this.enableRowClick) this.$emit("clickedRows", this.selectedRows);
      },
      dateRangeString() {
        if (this.dRange == null) return "All Dates";
        if (this.dRange.shortcut != undefined) {
          switch (this.dRange.shortcut) {
            case "day":
              return "Today";
            case "-day":
              return "Yesterday";
            case "isoWeek":
              return "This Week";
            case "-isoWeek":
              return "Last Week";
            case 7:
              return "Last 7 Days";
            case 30:
              return "Last 30 Days";
            case "month":
              return "This Month";
            case "-month":
              return "Last Month";
            case "year":
              return "This Year";
            case "-year":
              return "Last Year";
            default:
              return this.dRange.shortcut;
          }
        }
      },
      setDateField(h) {
        this.selectedDateField = h.value;
        this.selectedDateFieldText = h.text.replace("<br>", " ");
        this.dateDialog = true;
      },
      unhideColumns() {
        this.hiddenColumns = [];
      },
      isThisDateField(val) {
        let vals = this.filterDateTypes.filter((i) => i.value == val);
        return vals.length > 0 ? true : false;
      },
      hideThisColumn(h) {
        if (!this.hiddenColumns.includes(h.value))
          this.hiddenColumns.push(h.value);
      },
      searchFilter(h) {
        let oldFilterText = this.filterText;
        this.filterColumn.text = h.text;
        this.filterColumn.value = h.value;
        this.filterColumn.format = h.format;
        this.$refs["filterTextWidget"].value = "";
        this.filterText = null;
        if (oldFilterText != null) {
          this.options.page = 1;
          // this.updateSortedTable();
          this.needToUpdate = true;
        }
      },
      onResize() {
        if (!this.simple && !this.embed) {
          this.height = window.innerHeight - 220;
        } else {
          this.height = window.innerHeight - 120;
        }
        if (this.height < 400) this.toggleExclusive = 0;
        else if (this.height > 900) this.toggleExclusive = 2;
        else this.toggleExclusive = 1;
      },
      openDoc(t, f, v, i) {
        this.docdata = {
          table: t,
          field: f,
          value: v,
          item: i,
        };
        this.docdialog = true;
      },
      clearSearch() {},
      async returnValue(val) {
        this.sdialog = false;
        console.log("returnvalue: ", val);
        if (val == null) {
          return;
        }
        this.elog(
          "trace",
          "Edited Item = {} {} {} {}",
          val,
          this.editedIndex,
          this.table,
          this.simple
        )();
        if (!this.simple && !this.embed) {
          try {
            if (this.editedIndex < 0) {
              try {
                r = await this.tableserver.post("/dt/v1/" + this.table, val);
              } catch (e) {}
            } else {
              delete val.cts;
              delete val.ts;
              await this.tableserver.put(
                "/dt/v1/" + this.table + "/" + val._id,
                val
              );
            }
          } catch (ex) {
            this.elog("trace", "Potential issue while saving: {}", ex)();
          }
          let self = this;
          if (this.server == "login") {
            setTimeout(function () {
              // self.updateSortedTable()
              self.needToUpdate = true;
            }, 1000);
          }
        } else {
          let updatedRows;
          if (this.editedIndex < 0) {
            updatedRows = JSON.parse(JSON.stringify(this.rows));
            let i = this.getUniqueIndex();
            val["_id"] = i;
            val["item"] = i;
            updatedRows.push(val);
            this.$emit("updateTable", updatedRows, this.arrayKey);
          } else {
            updatedRows = this.rows.map((i) => (i._id == val._id ? val : i));
            this.$emit("updateTable", updatedRows, this.arrayKey);
          }
        }
        this.sdialog = false;
      },

      getUniqueIndex() {
        let nums = Array.from(Array(10).keys());
        this.rows.forEach((i) => {
          nums.splice(nums.indexOf(i._id), 1);
        });
        return nums[0];
      },
      deleteArryItem(item) {
        let updatedRows = this.rows.filter(function (obj) {
          return obj._id !== item._id;
        });
        this.$emit("updateTable", updatedRows, this.arrayKey);
      },

      setDateRange(val) {
        this.dRange = val;
        this.elog(
          "debug",
          "selected date range = {} for {}",
          val,
          this.selectedDateField
        )();
        this.updateDateRangeFilter();
      },
      updateDateRangeFilter() {
        let fval;
        this.options.page = 1;
        if (this.selectedDateField == null) {
          fval = "ts";
        } else {
          fval = this.selectedDateField;
        }
        if (this.dRange == null) {
          this.dfilter = [];
          // this.updateSortedTable();
          this.needToUpdate = true;
          return;
        }
        let dtype = {};
        if (this.selectedDateField == "cts" || this.selectedDateField == "ts") {
          dtype = `$${fval}`;
        } else {
          dtype = {
            $dateFromString: { dateString: `$${this.selectedDateField}` },
          };
        }

        (this.dfilter = [
          {
            $addFields: {
              dd: dtype,
            },
          },
          {
            $addFields: {
              de: { $dateFromString: { dateString: this.dRange.end } },
            },
          },
          {
            $addFields: {
              ds: { $dateFromString: { dateString: this.dRange.start } },
            },
          },
          {
            $match: {
              $expr: {
                $and: [{ $lte: ["$dd", "$de"] }, { $gte: ["$dd", "$ds"] }],
              },
            },
          },
          {
            $project: { dd: 0, de: 0, ds: 0 },
          },
        ]),
          // this.updateSortedTable();
          (this.needToUpdate = true);
      },
      toggleAdvanced() {
        this.advanced = !this.advanced;
      },
      getFieldValue(f) {
        if (f == null) {
          return null;
        }
        let h = this.headers.filter((v) => v.value == f);
        if (h == null || h.length == 0) return null;
        let field = utils.parseField(h[0].format);
        if (!field.type || field.type[0] != "id") return null;
        if (field.filter.length < 2) return null;
        let idTable = field.filter[0][0];
        let name = field.filter[1][0];
        return { table: idTable, field: name };
      },

      checkForImages(h) {
        if (h == undefined || h == null) return;
        this.elog("debug", "checking for image: {}", h)();
        var self = this;
        h.forEach((i) => {
          // let p = utils.parseField(i.format);
          if (i.format != undefined && i.format.includes("image")) {
            self.elog("debug", "table has images")();
            self.hasImages = true;
            return;
          }
        });
      },

      async realUpdateSortedTable(hideLoading) {
        this.elog("debug", "Updating Sorted Table")();
        this.rows = [];
        if (this.rowProp != null) {
          // static rows passed in via props
          this.rows = this.rowProp;
          this.needToUpdate = false;
          return;
        }
        let filterBy = this.filterText == null ? "" : this.filterText;
        if (this.table == null) {
          this.needToUpdate = false;
          return;
        }
        let p = "";
        this.tempImages = null;
        const ur = "/misc/dbops?c=" + this.table + "&op=pipe";
        let preFilter = "";
        let pipe = [];
        let skip = (this.options.page - 1) * this.options.itemsPerPage;
        let limit = this.options.itemsPerPage;
        let sortDir = this.options.descending ? -1 : 1;
        let ret;
        let m = [];

        // preFilter is for initial filtering of active and inactive items
        if (this.active) {
          preFilter = [{ $match: { $expr: { $ne: ["$IsUsed", "no"] } } }];
        } else {
          preFilter = [];
        }

        // Now check to see if any column is sorted
        let searchFilter = [];
        if (this.filterText != null && this.filterColumn.value != null) {
          let second;
          ret = this.getFieldValue(this.filterColumn.value);
          if (this.filterColumn.format) {
            let fields = utils.parseField(this.filterColumn.format);
            if (
              fields.filter &&
              fields.filter[1] &&
              fields.filter[1].length > 1
            ) {
              second = fields.filter[1][1];
            }
          }
          if (ret != null) {
            if (!second) second = ret.field;
            searchFilter = [
              {
                $project: {
                  search_id: {
                    $convert: {
                      input: `$${this.filterColumn.value}`,
                      to: "objectId",
                      onError: null,
                    },
                  },
                  document: "$$ROOT",
                },
              },
              {
                $lookup: {
                  from: ret.table,
                  localField: "search_id",
                  foreignField: "_id",
                  as: "search_field",
                },
              },
              {
                $project: {
                  search_name: "$search_field." + `${ret.field}`,
                  search_alt: "$search_field." + `${second}`,
                  document: "$document",
                },
              },
              { $unwind: "$search_name" },
              { $unwind: "$search_alt" },
              {
                $match: {
                  $or: [
                    { search_name: { $regex: `${filterBy}`, $options: "ig" } },
                    { search_alt: { $regex: `${filterBy}`, $options: "ig" } },
                  ],
                },
              },
              {
                $replaceRoot: { newRoot: "$document" },
              },
            ];
          } else {
            searchFilter = [
              {
                $match: {
                  [this.filterColumn.value]: {
                    $regex: `${filterBy}`,
                    $options: "ig",
                  },
                },
              },
            ];
          }
        }

        // now create sort filter
        let sortFilter = [];
        ret = this.getFieldValue(this.options.sortBy);
        if (ret != null) {
          sortFilter = [
            {
              $project: {
                temp_id: {
                  $convert: {
                    input: `$${this.options.sortBy}`,
                    to: "objectId",
                    onError: null,
                  },
                },
                document: "$$ROOT",
              },
            },

            {
              $lookup: {
                from: ret.table,
                localField: "temp_id",
                foreignField: "_id",
                as: "temp_field",
              },
            },
            {
              $project: {
                temp_name: "$temp_field." + ret.field,
                document: "$document",
              },
            },
            {
              $sort: {
                temp_name: sortDir,
              },
            },
            {
              $replaceRoot: { newRoot: "$document" },
            },
          ];
        } else if (this.options.sortBy && !Array.isArray(this.options.sortBy)) {
          sortFilter = [
            {
              $sort: {
                [this.options.sortBy]: sortDir,
              },
            },
          ];
        }

        var s = [{ $skip: skip }];
        var l = [{ $limit: limit }];
        var facet = this.active
          ? [
              {
                $facet: {
                  pages: s.concat(l),
                  total: [{ $count: "count" }],
                },
              },
            ]
          : [
              {
                $facet: {
                  pages: s.concat(l),
                },
              },
            ];

        pipe = m.concat(preFilter);
        if (this.dfilter != null && this.dfilter.length != 0) {
          pipe = pipe.concat(this.dfilter);
        }
        pipe = pipe.concat(searchFilter);
        pipe = pipe.concat(sortFilter);
        pipe = pipe.concat(facet);

        if (this.server == "login") {
          this.tableserver = axiosInstances.loginServer;
        } else if (this.server == "auth") {
          this.tableserver = axiosInstances.authServer;
        } else if (this.server == "orig") {
          this.tableserver = axiosInstances.origApiServer;
        } else {
          this.tableserver = axiosInstances.apiServer;
        }
        if (!hideLoading) this.tableLoading = true;
        this.elog("trace", "URL and server {} {}", ur, this.server)();
        this.elog("trace", "pipe = {}", JSON.stringify(pipe))();
        const resP = await this.tableserver.post(ur, pipe);
        await utils.cacheObjectReferences(resP.data, this.headers);

        if (this.active) {
          this.serverItemsLength = resP?.data[0]?.total[0]?.count || 0;
        } else {
          const totalCount = await this.tableserver.get(
            "/dt/v1/" + this.tableName + "?count"
          );
          this.serverItemsLength =
            totalCount == null || totalCount.data == null
              ? 0
              : totalCount.data.count;
        }
        if (
          resP.data == null ||
          resP.data[0] == null ||
          this.serverItemsLength == 0
          // resP.data[0].total[0] == null
        ) {
          this.elog("error", "No rows to display {} ", resP)();
          // this.$toasted.show('This table is empty', {type: 'info', duration: 5 * 1000})
          this.rows = [];
          // this.serverItemsLength = 0;
          this.tableLoading = false;
          this.needToUpdate = false;
          return;
        }

        // this.showHeaders = this.headers
        this.rows = resP.data[0].pages;
        this.hideEmptyColumns(this.headers, this.rows);
        this.tableLoading = false;
        this.needToUpdate = false;
        await this.getImages();
        this.elog("debug", "images: {}", this.images)();
      },

      itemClass(item, h, editables) {
        if (h.format.search("tax") >= 0) {
          let val = utils.formatItem({ i: item, h: h, e: editables, t: true });
          let color;
          switch (val) {
            case "Paid":
              color = "green--text";
              break;
            case "Pending":
              color = "orange--text";
              break;
            case "Due":
              color = "red--text";
              break;
          }
          return color;
        }
      },
      clickIcon(item, val) {
        if (this.clickAction[val].t === "check") {
          if (item[val] === "yes") return [this.clickAction[val].u, "green"];
          else return [this.clickAction[val].d, "green"];
        }
        if (this.clickedRowId == item._id && this.clickedCellValue == val) {
          return [this.clickAction[val].u, "red"];
        } else {
          return [this.clickAction[val].d, "green"];
        }
      },
      getAlignment(align) {
        return align === "right" ? "text-xs-right" : "text-xs-left";
      },
      isImage(h) {
        let p = utils.parseField(h.format);
        if (p != undefined && p.filter != undefined && p.filter[0] == "image") {
          return true;
        }
        return false;
      },
      async getImages() {
        if (!this.hasImages) return;
        var tempImages = {};
        var self = this;
        self.images = {};
        // this.rows.forEach(async function(i) {
        for (const i of this.rows) {
          if (!this.imagesOnServer.includes(i._id + ".png")) continue;
          var url =
            "/getfiles/" +
            self.user.org +
            "/" +
            i._id +
            ".png?subdir=" +
            this.table;
          let img = null;
          try {
            img = await axiosInstances.apiServer.get(url, {
              responseType: "arraybuffer",
            });
          } catch (err) {
          } finally {
          }
          if (img != null) {
            var bytes = new Uint8Array(img.data);
            var binary = bytes.reduce(
              (data, b) => (data += String.fromCharCode(b)),
              ""
            );
            var imgsrc = btoa(binary);
            if (imgsrc != null && imgsrc != "") {
              this.$set(this.images, i._id, "data:image/png;base64," + imgsrc);
              self.hideEmptyColumns(self.headers, self.rows, true);
            } else {
              this.elog("debug", "no image for: {}", i._id)();
            }
          }
          // } catch {}
        }
        // this.tempImages = tempImages;
        // this.images = this.tempImages;
        this.elog("trace", "images: {}", this.images)();
      },
      formatItem(item) {
        let f = utils.formatItem(item);
        return f;
      },
      showItemPrintButtons() {
        if (this.printerObj && this.printerObj["field"] == "id:prt")
          return true;
        return false;
      },
      async customFilter(items, search, filter) {
        let self = this;
        search = search.toString().toLowerCase();
        if (self.headers == undefined) {
          return items;
        }
        return items.filter(async function (i) {
          return self.headers.some(async function (h, idx) {
            let temp,
              key = h.value;
            if (h.format) {
              temp = await utils.formatItem({ i: i, h: h, e: self.editables });
              return filter(temp, search);
            }
            return filter(i[key], search);
          });
        });
      },

      isArray(item) {
        let match = this.editables.filter((i) => item == i.name);
        if (match.length > 0) return match[0].array;
        return false;
      },
      cellClicked(item, h) {
        let tag = h.value;
        if (this.clickedRowId == item._id) {
          this.clickedRowId = null;
          this.clickedRowId = null;
        } else {
          this.clickedRowId = item._id; // this.clickedRowId == item._id //? null : item._id
          this.clickedCellValue = h.value; // this.clickedCellValue == tag //? null : tag
        }

        // return // TBD
        // if (!this.expanded.includes(item)) this.expanded.push(item)
        let i = this.clickAction[h.value];
        // if (!i || typeof i !== "object") return;
        if (i["t"] === "array") {
          if (!i || typeof i !== "object") return;
          let f = this.editables.filter((i) => i.name == h.value);
          if (f.length > 0) f = f[0];
          this.exRowProp = item[h.value];
          this.exSchemaProp = f.headerTable;
          this.excomponent = null; //SimpleTable;
        } else if (i["t"] === "file") {
          this.dndClicked(item, tag);
        } else if (i["t"] === "check") {
          item[tag] = item[tag] == "yes" ? "no" : "yes";
        }
      },
      dndClicked(item, tag) {
        var self = this;
        let tagitem = this.editables.filter((i) => i.name == tag);
        tagitem = tagitem[0];
        let dir = tagitem.dir;
        let f = item[tag];
        var link = document.createElement("a");
        link.href =
          axiosInstances.apiServer.defaults.baseURL +
          "/getfiles/" +
          this.user.org +
          "/" +
          f +
          "?subdir=" +
          dir +
          "&token=" +
          localStorage.token;
        link.download = this.filename;
        if (!self.$store.state.misc.webview) {
          link.target = "_blank"; //target new tab
        }
        try {
          link.click();
        } catch (ex) {
          this.elog("error", "{}", ex)();
        }
        return;
        axiosInstances.apiServer
          .get("/getfiles/" + this.user.org + "/" + f + "?subdir=" + dir, {
            responseType: "arraybuffer",
          })
          .then((response) => {
            var blob = new Blob([response.data], {
              type: "application/pdf" /*headers['content-type']*/,
            });
            if (self.$store.state.webview) {
              fetch("http://reports.entrinsia.net/" + uuid.v4() + ".pdf", {
                method: "PUT",
                body: blob,
                headers: {
                  "Content-Type": "application/pdf",
                },
              });
              setTimeout(function () {
                link.href =
                  "http://reports.entrinsia.net/" + uuid.v4() + ".pdf";
                link.click();
              }, 1000);
            } else {
              var link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = f;
              // link.target = '_blank'
              link.click();
            }
          })
          .catch((ex) => {
            this.elog("error", "{}", ex)();
            // self.$store.commit("SET_ALERT", {
            //   show: true,
            //   msg: "Can not get file",
            //   color: "error",
            // });
            this.$toasted.show("Can not get file", {
              type: "error",
              duration: 5 * 1000,
            });
          });
      },
      changeSort(column) {
        if (this.options.sortBy === column) {
          this.options.descending = !this.options.descending;
        } else {
          this.options.sortBy = column;
        }
        this.options.page = 1;
        // this.updateSortedTable();
        this.needToUpdate = true;
      },

      async addItem() {
        this.editedIndex = -1;
        this.editedItem = {};
        var self = this;
        console.log(`Add Item Table = ` + self.table);
        let cb = self.table + "_add_callback";

        if (self[cb] == undefined) {
          self.editables.forEach(function (item) {
            if (item.name == "octs") {
              self.editedItem.octs = self.editedItem.cts;
            }
            if (item.measure) {
              self.editedItem[item.name] = { qty: 0, unit: item.units[0] };
            }
          });
          self.sdialog = true;
          return;
        } else {
          self.formdata = await self[cb]();
          self.formdialog = true;
          return;
        }
        let ret = self[cb]();
        if (ret == "stop") {
          return;
        } else if (ret == "continue") {
          self.editables.forEach(function (item) {
            if (item.name == "octs") {
              self.editedItem.octs = self.editedItem.cts;
            }
            if (item.measure) {
              self.editedItem[item.name] = { qty: 0, unit: item.units[0] };
            }
          });
          self.sdialog = true;
          return;
        } else {
          //display error
          this.$root
            .$confirm("Error", ret, {
              color: "red",
              nocancel: true,
              ok: "OK",
            })
            .then(async function (confirm) {
              return;
            });
        }
      },
      async editItem(item) {
        delete item.dup;
        var self = this;
        this.editedIndex = this.rows.findIndex((x) => x._id == item._id);
        this.editedItem = JSON.parse(JSON.stringify(item));
        this.elog(
          "debug",
          "Editing item {} {} {}",
          this.editedIndex,
          this.editedItem,
          this.editables
        )();
        var self = this;
        let cb = self.table + "_edit_callback";
        if (self[cb] === undefined) {
          this.editables.forEach(function (item) {
            if (item.name == "octs") {
              self.editedItem.octs = self.editedItem.cts;
            }
            if (item.measure) {
              if (self.editedItem[item.name] == null)
                self.editedItem[item.name] = { qty: 0, unit: item.units[0] };
            }
          });
          this.sdialog = true;
        } else {
          self.formdata = await self[cb](self.editedItem);
          self.formdialog = true;
          return;
        }
      },
      printItem(item) {
        let topic = this.user.org + "/request/" + this.printerObj.deviceid;
        let d = {
          template: this.printerObj.template,
          id: item._id,
          table: this.table,
        };
        let payload = {
          server: this.currentOrg.server,
          org: this.currentOrg.name,
          data: [d],
        };
        this.mqttClient.publish(topic, JSON.stringify(payload));
        Vue.set(this.printIcons, item._id, false);
        let self = this;
        setTimeout(function () {
          self.printIcons[item._id] = true;
        }, 20000);
      },
      async deleteItem(item) {
        var self = this;
        if (!this.embed) {
          this.$root
            .$confirm("Delete", "Are you sure you want to delete this item?", {
              color: "red",
            })
            .then(async function (confirm) {
              if (confirm) {
                let cb = self.table + "_delete_callback";
                if (self[cb] == undefined) {
                  if (self.simple) {
                    self.deleteArryItem(item);
                    return;
                  }
                  await self.tableserver.delete(
                    "/dt/v1/" + self.table + "/" + item._id
                  );
                  return;
                }
                let rcb = await self[cb](item);
                if (rcb == "stop") {
                  return;
                } else if (rcb == "continue") {
                  await self.tableserver.delete(
                    "/dt/v1/" + self.table + "/" + item._id
                  );
                  if (self.refresh) {
                    // self.updateSortedTable();
                    self.needToUpdate = true;
                  }
                } else {
                  this.$root
                    .$confirm("Error", rcb, {
                      color: "red",
                      nocancel: true,
                      ok: "OK",
                    })
                    .then(async function (confirm) {
                      return;
                    });
                }
              }
            });
        } else {
          this.$root
            .$confirm("Delete", "Are you sure you want to delete this item?", {
              color: "red",
            })
            .then(function (confirm) {
              if (confirm) {
                self.deleteArryItem(item);
              }
            });
        }
      },
      hideEmptyColumns(header, rows, hasImages = false) {
        let self = this;
        let newHiddenColumns = [];
        header.forEach((h) => {
          let k = h.value;
          let rmap = rows.filter((r) => k in r && r[k]);
          if (rmap.length == 0) {
            if (!hasImages) {
              if (!newHiddenColumns.includes(k)) newHiddenColumns.push(k);
            } else {
              if (
                h.format &&
                !h.format.includes("image") &&
                !newHiddenColumns.includes(k)
              )
                newHiddenColumns.push(k);
            }
          }
        });
        this.hiddenColumns = newHiddenColumns;
      },
      async init() {
        this.options.page = 1;
        this.imagesOnServer = [];
        // cache.reset()
        this.elog("debug", "updating sorted table from init")();
        this.elog(
          "trace",
          "SCHEMA PROP, schema: {} {}",
          this.schemaProp,
          this.schema
        )();
        if (this.schemaProp != null) {
          this.headers = this.schemaProp.headers;
          this.editables = this.schemaProp.editables;
        } else {
          var sch;
          try {
            sch = await preprocess.getTableSchema(this.schema, this.language);
          } catch (ex) {
            this.$toasted.show(
              "Could not access server, please try again later",
              { type: "error" }
            );
            return;
          }
          this.tableName = this.table;
          this.headers = sch.headers;
          this.editables = sch.editables;
          this.filterDateTypes = this.headers.filter(
            (i) => i.format != undefined && i.format.includes("date")
          );
        }
        this.elog("debug", "Headers: {}", this.headers)();
        this.elog("debug", "Editables: {}", this.editables)();
        if (this.server == "login") {
          this.tableserver = axiosInstances.loginServer;
        } else if (this.server == "auth") {
          this.tableserver = axiosInstances.authServer;
        } else {
          this.tableserver = axiosInstances.apiServer;
        }
        this.checkForImages(this.headers);
        if (this.hasImages) {
          // get directory listing for image folder
          var imgFolder = null;
          try {
            imgFolder = await axiosInstances.apiServer.get(
              "/getfiles/" + this.user.org + "/?subdir=" + this.table
            );
          } catch (err) {}
          if (imgFolder != null && imgFolder.data != null) {
            this.imagesOnServer = imgFolder.data;
          }
        }
        // await this.updateSortedTable();
        this.needToUpdate = true;
        // this.elog("debug", "Rows: {}", this.rows)();
      },

      resizableGrid(table) {
        var row = table.getElementsByTagName("tr")[0],
          cols = row ? row.children : undefined;
        if (!cols) return;

        table.style.overflow = "hidden";

        var tableHeight = table.offsetHeight;

        for (var i = 0; i < cols.length; i++) {
          var div = createDiv(tableHeight);
          cols[i].appendChild(div);
          cols[i].style.position = "relative";
          setListeners(div);
        }

        function setListeners(div) {
          var pageX, curCol, nxtCol, curColWidth, nxtColWidth;

          div.addEventListener("mousedown", function (e) {
            curCol = e.target.parentElement;
            nxtCol = curCol.nextElementSibling;
            pageX = e.pageX;

            var padding = paddingDiff(curCol);

            curColWidth = curCol.offsetWidth - padding;
            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding;
          });

          div.addEventListener("mouseover", function (e) {
            e.target.style.borderRight = "2px solid #0000ff";
          });

          div.addEventListener("mouseout", function (e) {
            e.target.style.borderRight = "";
          });

          document.addEventListener("mousemove", function (e) {
            if (curCol) {
              var diffX = e.pageX - pageX;

              if (nxtCol) nxtCol.style.width = nxtColWidth - diffX + "px";

              curCol.style.width = curColWidth + diffX + "px";
            }
          });

          document.addEventListener("mouseup", function (e) {
            curCol = undefined;
            nxtCol = undefined;
            pageX = undefined;
            nxtColWidth = undefined;
            curColWidth = undefined;
          });
        }

        function createDiv(height) {
          var div = document.createElement("div");
          div.style.top = 0;
          div.style.right = 0;
          div.style.width = "5px";
          div.style.position = "absolute";
          div.style.cursor = "col-resize";
          div.style.userSelect = "none";
          div.style.height = height + "px";
          return div;
        }

        function paddingDiff(col) {
          if (getStyleVal(col, "box-sizing") == "border-box") {
            return 0;
          }

          var padLeft = getStyleVal(col, "padding-left");
          var padRight = getStyleVal(col, "padding-right");
          return parseInt(padLeft) + parseInt(padRight);
        }

        function getStyleVal(elm, css) {
          return window.getComputedStyle(elm, null).getPropertyValue(css);
        }
      },
    },

    async created() {
      // await this.init();
    },

    async mounted() {
      this.needToUpdate = false;
      await this.init();
      if (this.preMountedMixin) {
        this.preMountedMixin();
      }

      var self = this;
      this.dialogProp.component = this.dialogMainComponent;

      this.tempImages = null;
      this.printIcons = {};
      this.clickAction = {};
      this.fullPage = true;

      window.addEventListener("resize", this.onResize);
      this.$nextTick(this.onResize);
      if (this.postMountedMixin) {
        this.postMountedMixin();
      }
    },
    beforeDestroy() {
      this.rows = null;
      this.tempImages = null;
    },
  };
</script>

<style scoped>
  .v-dialog {
    height: 90%;
    width: 90%;
    overflow-y: hidden !important;
  }
  #mycontainer {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0px;
  }
  #outer {
    flex: 1;
  }
  .top-v-data-table {
    line-height: 1.25;
    border-style: solid;
    border: 1px solid gray;
    border-collapse: collapse !important;
  }
  .inset-v-data-table {
    color: black;
    line-height: 1.25;
    border-style: solid;
    border: 1px dashed gray;
    background-color: #e3e0dc;
    border-collapse: collapse !important;
  }
  .inset-v-data-table-dark {
    color: lightgray;
    line-height: 1.25;
    border-style: solid;
    border: 1px dashed;
    background-color: #292827;
    border-collapse: collapse !important;
  }
  th {
    font-size: 16px !important;
    font-weight: bold;
    white-space: nowrap;
    vertical-align: bottom;
    z-index: 5;
  }

  .v-btn2 {
    min-width: 36px;
    background-color: cornflowerblue !important;
    margin: 0px;
    padding: 2px;
    height: 30px !important;
  }
  .v-btn__content {
    color: lightgray !important;
  }
  .v-data-table v-input {
    font-size: 10px !important;
    height: 14px;
  }
  .v-select v-input__control v-input__slot {
    font-size: 10px !important;
  }

  #colselect .v-label {
    font-size: 10px !important;
  }
  .v-datatable thead th.column.sortable.active.desc .no-rotate {
    transform: none !important;
  }
  #fselector .v-btn-toggle {
    flex-direction: column;
  }
  .v-tooltip__content {
    font-size: 14px !important;
    opacity: 1 !important;
    background: black;
  }
  /* @media print {
    body * {
        visibility: hidden;
        font-size: 20px !important;
    }

    #print, #print * {
        visibility: visible;
        border-bottom: none;
    }

    #title {
        visibility: hidden;
    }

    #print {
        padding: 20px;
        position: fixed; 
        height: 100%;
        left: 0;
        top: 0;
    }
} */
</style>
